import { createApi } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import {
  showSessionExpiredModal,
  showAccessDeniedModal,
} from "../slices/authSlice";
import getTenantId from "../../components/Tenent";

const getStore = () => require("../store").store;

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_AI_DASHBOARD,
  withCredentials: true,
  headers: { accept: "application/json" },
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers["x-tenant-id"] = getTenantId();
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname !== "/login") {
      getStore().dispatch(showSessionExpiredModal(window.location.pathname));
    }
    return Promise.reject(err);
  }
);

const axiosBaseQuery =
  () =>
  async ({ url, method, body, params, ...requestOpts }) => {
    try {
      const result = await axiosInstance({
        url,
        method,
        data: body,
        params,
        headers: requestOpts.headers,
      });
      return { data: result.data };
    } catch (axiosError) {
      const errorData = axiosError.response?.data;
      const status = axiosError.response?.status;
      if (status === 403 && errorData?.error === "forbidden") {
        getStore().dispatch(showAccessDeniedModal());
      }
      return { error: { status, data: errorData || axiosError.message } };
    }
  };

export const analyticsDashboard = createApi({
  reducerPath: "analyticsDashboard",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["analyticsDashboard"],
  endpoints: (builder) => ({
    getPrompt: builder.mutation({
      query: (data) => ({
        url: `api/ghg/dashboard_bot`,
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { useGetPromptMutation } = analyticsDashboard;
